import { render, staticRenderFns } from "./editZigongsi.vue?vue&type=template&id=70ac4a7e&scoped=true"
import script from "./editZigongsi.vue?vue&type=script&lang=js"
export * from "./editZigongsi.vue?vue&type=script&lang=js"
import style0 from "./editZigongsi.vue?vue&type=style&index=0&id=70ac4a7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac4a7e",
  null
  
)

export default component.exports